const actions = {
  SET_STATE: 'group/SET_STATE',
  LOAD_GROUP: 'group/LOAD_GROUP',
  CREATE_NEW_POST: 'group/CREATE_NEW_POST',
  GET_GROUP_POST: 'group/GET_GROUP_POST',
  LIKE_POST: 'group/LIKE_POST',
  MAKE_POST_TRACKED: 'group/MAKE_POST_TRACKED',
  CREATE_POST_COMMENT: 'group/CREATE_POST_COMMENT',
}

export default actions
